import environment from '@/environment'

const RESOURCE_DASHBOARD_URL = 'https://sympower.app.eu2.coralogix.com/#/dashboards/bXhwHPL8J4NpqcwVXwV06'

/**
 * The dashboard's `environment` template variable is a Kubernetes cluster name
 * (e.g. `staging-eks-1`), not FlexPortal's `environmentName`. Only production is
 * isolated; staging, development and branch deploys all read from the staging
 * backend, so they share the staging cluster.
 */
const CLUSTER_BY_ENVIRONMENT: Record<string, string> = {
  staging: 'staging-eks-1',
  production: 'production-eks-1',
}

/**
 * Deep link to a resource's Coralogix "Resource & Market Reports" dashboard, for
 * inspecting its live telemetry while prequalifying.
 *
 * `var-environment` is set explicitly rather than relying on the dashboard's saved
 * default, so a link opened from production points at production data.
 */
export function makeResourceDashboardLink(resourceId: string): string {
  const cluster = CLUSTER_BY_ENVIRONMENT[environment.environmentName] ?? 'staging-eks-1'
  const params = new URLSearchParams({
    from: 'now-300s',
    to: 'now',
    'var-environment': cluster,
    'var-resource_id': resourceId,
  })
  return `${RESOURCE_DASHBOARD_URL}?${params.toString()}`
}
